
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

const sizesList = [
    '1', '2', '1', '2', '1', '1', '1', '1', '2',
];
const sizesListLaptop = [
    '1', '1', '2', '1', '1', '2', '1', '1', '2',
];

export default BaseCmsBlock.extend({
    name: 'ApartmentCharacteristicsBlock',

    computed: {
        items() {
            return this.values.items;
        },
    },

    methods: {
        getClassSize(index) {
            const factor = Math.floor(index / 9);
            if (index >= 9) {
                index -= ((factor || 1) * 9);
            }

            return `size-${sizesList[index]} size-laptop-${sizesListLaptop[index]}`;
        },
    },
});
